import { CourseLevelEnum } from '../../models/enums/courseLevelEnum';
import { Step, country, gender, source } from './register-state.model';

export class UpdateEmailVerification {
  static readonly type = '[Register] Update Email Verification';
  constructor(public payload: { email: string; emailVerified: boolean }) {}
}

export class UpdateSetPassword {
  static readonly type = '[Register] Update Set Password';
  constructor(public payload: { password: string; confirmPassword: string }) {}
}

export class UpdatePersonalDetails {
  static readonly type = '[Register] Update Personal Details';
  constructor(public payload: { name: string }) {}
}

export class UpdateGenderSelection {
  static readonly type = '[Register] Update Gender Selection';
  constructor(public payload: { gender: gender }) {}
}

export class UpdateDateOfBirth {
  static readonly type = '[Register] Update Date of Birth';
  constructor(public payload: { bornOn: { day: string; month: string; year: string } }) {}
}

export class UpdateDegreePreference {
  static readonly type = '[Register] Update Applying As';
  constructor(public payload: { degreePreference: CourseLevelEnum }) {}
}
export class UpdateIntendedMajor {
  static readonly type = '[Register] Update Intended Major';
  constructor(public payload: { intendedMajor: string }) {}
}

export class UpdatePerviousCourseCompletionOn {
  static readonly type = '[Register] Update PerviousCourseCompletion On';
  constructor(public payload: { perviousCourseCompletionOn: string }) {}
}

export class UpdateCollegeStart {
  static readonly type = '[Register] Update College Start';
  constructor(public payload: { collegeStartOn: string }) {}
}

export class UpdateHearAboutUs {
  static readonly type = '[Register] Update Hear About Us';
  constructor(public payload: { hearabouts: source[] }) {}
}
export class UpdateHomeCountry {
  static readonly type = '[Register] Update Home Country';
  constructor(public payload: { homeCountry: country }) {}
}

export class UpdateDestination {
  static readonly type = '[Register] Update Destination';
  constructor(public payload: { destination: country[] }) {}
}

export class UpdateAcademicsPreferences {
  static readonly type = '[Register] Update Academics Preferences';
  constructor(
    public payload: {
      academics: string[];
      studentLife: string[];
      costAndOutcomes: string[];
    }
  ) {}
}

export class UpdateJourneyPreferences {
  static readonly type = '[Register] Update Journey Preferences';
  constructor(public payload: { journey: string[] }) {}
}

export class UpdateCurrentStep {
  static readonly type = '[Register] Update Current Step';
  constructor(public payload: { step: Step }) {}
}

export class UpdateTemporaryToken {
  static readonly type = '[Register] Update Temporary Token';
  constructor(public payload: { token: string }) {}
}
